import { useState } from "react";

export default function CancelledWall({ user, API_BASE, dashState }) {
  const [reactivatingFree, setReactivatingFree] = useState(false);
  const [reactivatingPaid, setReactivatingPaid] = useState(false);
  const [error, setError] = useState(null);

  const G = "#0077B5";
  const planName = user?.last_paid_plan
    ? user.last_paid_plan.charAt(0).toUpperCase() + user.last_paid_plan.slice(1)
    : null;

  const cancelledAt = user?.cancelled_at
    ? new Date(user.cancelled_at).toLocaleDateString("en-CA", { month: "long", day: "numeric", year: "numeric" })
    : null;

  const handleReactivateFree = async () => {
    setReactivatingFree(true);
    setError(null);
    try {
      const r = await fetch(`${API_BASE}/app/api/user/reactivate-free`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-Session-Token": localStorage.getItem("nectar_st"),
        },
      });
      const data = await r.json();
      if (r.ok) {
        window.location.reload();
      } else {
        setError(data.error || "Something went wrong. Please try again.");
        setReactivatingFree(false);
      }
    } catch {
      setError("Network error. Please try again.");
      setReactivatingFree(false);
    }
  };

  const handleReactivatePaid = async () => {
    setReactivatingPaid(true);
    setError(null);
    try {
      const r = await fetch(`${API_BASE}/app/api/billing/portal-session`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-Session-Token": localStorage.getItem("nectar_st"),
        },
      });
      const data = await r.json();
      if (r.ok && data.portal_url) {
        window.location.href = data.portal_url;
      } else {
        setError(data.error || "Could not open billing portal.");
        setReactivatingPaid(false);
      }
    } catch {
      setError("Network error. Please try again.");
      setReactivatingPaid(false);
    }
  };

  const busy = reactivatingFree || reactivatingPaid;

  const style = {
    wrap: { background: "#F3F2EF", minHeight: "100vh", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif" },
    inner: { maxWidth: 560, margin: "0 auto", padding: "48px 24px 80px" },
    logo: { fontFamily: "'Playfair Display',Georgia,serif", fontSize: 24, fontWeight: 700, color: G, display: "block", marginBottom: 40, textDecoration: "none" },
    heading: { fontFamily: "'Playfair Display',Georgia,serif", fontSize: 26, fontWeight: 700, color: "#1A1A1A", marginBottom: 12, lineHeight: 1.3 },
    body: { fontSize: 15, color: "#666", lineHeight: 1.7, marginBottom: 24 },
    preserved: { background: "#F0FDF4", border: "1px solid #BBF7D0", borderRadius: 10, padding: "14px 20px", fontSize: 14, color: "#166534", marginBottom: 28, lineHeight: 1.6 },
    error: { background: "#FEF2F2", border: "1px solid #FECACA", borderRadius: 8, padding: "12px 16px", color: "#B91C1C", fontSize: 14, marginBottom: 16 },
    ctaPrimary: { width: "100%", background: "#22C55E", color: "#fff", border: "none", borderRadius: 10, padding: "17px", fontSize: 17, fontFamily: "'Playfair Display',Georgia,serif", cursor: busy ? "not-allowed" : "pointer", opacity: busy ? 0.7 : 1, marginBottom: 12 },
    ctaSecondary: { width: "100%", background: "transparent", color: G, border: `1.5px solid ${G}`, borderRadius: 10, padding: "15px", fontSize: 15, fontFamily: "'Playfair Display',Georgia,serif", cursor: busy ? "not-allowed" : "pointer", opacity: busy ? 0.7 : 1, marginBottom: 8 },
    meta: { fontSize: 13, color: "#aaa", textAlign: "center", marginTop: 20, lineHeight: 1.6 },
    footer: { textAlign: "center", marginTop: 48, fontSize: 12, color: "#ccc" },
  };

  return (
    <div style={style.wrap}>
      <div style={style.inner}>
        <a href="https://brandhives.com" style={style.logo}>BrandHives</a>

        <div style={style.heading}>Your account has been cancelled.</div>

        <div style={style.body}>
          {planName
            ? `You cancelled your ${planName} plan. Your LinkedIn posting has been paused, but nothing has been deleted.`
            : "Your account has been cancelled. Your LinkedIn posting has been paused, but nothing has been deleted."}
        </div>

        <div style={style.preserved}>
          Your content, settings, and posting history are all preserved forever. Pick up right where you left off.
        </div>

        {error && <div style={style.error}>{error}</div>}

        <button style={style.ctaPrimary} onClick={handleReactivateFree} disabled={busy}>
          {reactivatingFree ? "Reactivating\u2026" : "Continue on Free plan"}
        </button>

        <button style={style.ctaSecondary} onClick={handleReactivatePaid} disabled={busy}>
          {reactivatingPaid ? "Opening billing\u2026" : "Resubscribe to a paid plan"}
        </button>

        {cancelledAt && (
          <div style={style.meta}>Cancelled on {cancelledAt}</div>
        )}

        <div style={style.footer}>
          AI by Claude &middot; Payments secured by Stripe &middot; Developed by BHIVE Labs
        </div>
      </div>
    </div>
  );
}
